import React, { useEffect, useState } from "react";
import {
  CButton,
  CCard,
  CRow,
  CCol,
  CCardHeader,
  CForm,
  CCardFooter,
  CFormLabel,
  CFormInput,
  CBadge,
} from "@coreui/react";
import { useLocation, useNavigate } from "react-router-dom";
import { insert, update, remove } from "src/services/Categories";
import CIcon from "@coreui/icons-react";
import { cilTrash } from "@coreui/icons";
import { Toaster } from "src/components/Toaster";
import ls from "local-storage";
import Select, { components } from "react-select";
function CategoryActions() {
  const [id, setID] = useState(0);
  const [name, setName] = useState("");
  const [validated, setValidated] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [isEdit, setIsEdit] = useState(false);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [color, setColor] = useState("");

  useEffect(() => {
    if (location.state) {
      setIsEdit(true);
      setID(location.state.id);
      setName(location?.state?.name ?? "");
    }
  }, [location]);

  async function fDelete() {
    await remove(id).then((response) => {
      if ((response?.data?.success ?? 0) == 1) {
        setMessage(response?.data?.message);
        setOpen(true);
        const data = () =>
          setTimeout(() => {
            navigate(-1);
          }, 2000);

        data();

        return clearTimeout(data);
      } else {
        setMessage(response?.data?.message);
        setOpen(true);
        setColor("red");
      }
    });
  }
  async function handleSubmit(e) {
    const form = e.currentTarget;
    e.preventDefault();
    e.stopPropagation();

    if (form.checkValidity() === false) {
    } else {
      let data = {
        id: id,
        name: name,
      };
      if (location.state) {
        await update(data).then((response) => {
          if ((response?.data?.success ?? 0) == 1) {
            setMessage(response?.data?.message);
            setOpen(true);
            const data = () =>
              setTimeout(() => {
                navigate(-1);
              }, 2000);

            data();

            return clearTimeout(data);
          } else {
            setMessage(response?.data?.message);
            setOpen(true);
            setColor("red");
          }
        });
      } else {
        await insert(data).then((response) => {
          if ((response?.data?.success ?? 0) == 1) {
            setMessage(response?.data?.message);
            setOpen(true);
            const data = () =>
              setTimeout(() => {
                navigate(-1);
              }, 2000);

            data();

            return clearTimeout(data);
          } else {
            setMessage(response?.data?.message ?? ls.get("errorMessage"));
            setOpen(true);
            setColor("red");
          }
        });
      }
    }
    setValidated(true);

    // e.preventDefault()
    // console.log('bener')
  }
  return (
    <CCard>
      <Toaster open={open} message={message} setOpen={setOpen} ahd={1500} color={color ?? "green"} />
      <CCardHeader>Actions - Produk</CCardHeader>
      <CForm onSubmit={(e) => handleSubmit(e)} noValidate validated={validated}>
        <div style={{ margin: "16px" }}>
          <CRow className="mb-3">
            <CCol md={3}>
              <CFormLabel>Nama</CFormLabel>&nbsp;
              <CBadge color="warning">Wajib</CBadge>
            </CCol>
            <CCol>
              <CFormInput
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                feedbackInvalid="Required value"
                required
              />
            </CCol>
          </CRow>
        </div>
        <CCardFooter style={{ textAlign: "right" }}>
          {location.state ? (
            <CButton
              color="danger"
              onClick={() => {
                fDelete();
              }}
            >
              <CIcon icon={cilTrash} />
            </CButton>
          ) : (
            <div></div>
          )}
          &emsp;
          <CButton
            style={{
              color: "black",
              backgroundColor: "white",
            }}
            onClick={() => {
              navigate(-1);
            }}
          >
            Cancel
          </CButton>
          &emsp;
          <CButton
            color="success"
            style={{
              color: "white",
            }}
            type="submit"
          >
            Save
          </CButton>
        </CCardFooter>
      </CForm>
    </CCard>
  );
}

export default CategoryActions;
